import { ROLES } from '../constants/roles';

/** Maps sidebar paths to view-permission module keys */
export const PATH_TO_MODULE_KEY = {
  '/': 'dashboard',
  '/am-dashboard': 'am-dashboard',
  '/am-mro-dashboard': 'am-mro-dashboard',
  '/ops-dashboard': 'ops-dashboard',
  '/crew-duty-roster': 'crew-duty-roster',
  '/sales': 'sales',
  '/ops': 'ops',
  '/camo-dashboard': 'camo-dashboard',
  '/aircraft-lifecycle': 'aircraft-lifecycle',
  '/master-data': 'master-data',
  '/maintenance': 'maintenance',
  '/amp-schedules': 'amp-schedules',
  '/adsb-service-bulletin': 'adsb-service-bulletin',
  '/technical-log-book': 'technical-log-book',
  '/admin/technical-log-book-format': 'technical-log-book-format',
  '/authorization': 'certification-authorization',
  '/certification-authorization': 'certification-authorization',
  '/authorization/non-certifying': 'certification-authorization',
  '/non-certifying-staff-authorization': 'certification-authorization',
  '/authorization/instructor': 'certification-authorization',
  '/instructor-authorization': 'certification-authorization',
  '/authorization/one-off': 'certification-authorization',
  '/one-off-authorization': 'certification-authorization',
  '/planning': 'planning',
  '/store': 'store',
  '/store/inventory': 'store-inventory',
  '/store/returns': 'store-returns',
  '/receiving-and-inspection': 'receiving-and-inspection',
  '/issuance': 'issuance',
  '/procurement': 'procurement',
  '/loan': 'loan',
  '/users': 'users',
  '/users/onboard': 'users-onboard',
  '/client-settings': 'client-settings',
  '/audit': 'audit',
  '/mis-dashboard': 'mis-dashboard',
  '/roles-glossary': 'roles-glossary',
  '/aircraft': 'aircraft',
  '/serialized-items': 'serialized-items',
  '/parts-catalog': 'parts-catalog',
  '/mro': 'mro',
  '/mro/lab': 'mro-lab',
  '/mro/lab/planning': 'mro-lab',
  '/mro/lab/manager': 'mro-lab',
  '/mro/lab/engineer': 'mro-lab',
  '/mro/lab/qm': 'mro-lab',
  '/dgca-baseline': 'dgca-baseline',
  '/report-center': 'report-center'
};

export function getModuleKeyFromPath(path) {
  if (PATH_TO_MODULE_KEY[path]) return PATH_TO_MODULE_KEY[path];
  if (path.startsWith('/mro/lab')) return 'mro-lab';
  if (path.startsWith('/users/onboard')) return 'users-onboard';
  if (path.startsWith('/store/inventory')) return 'store-inventory';
  if (path.startsWith('/store/returns')) return 'store-returns';
  if (path.startsWith('/store')) return 'store';
  if (path.startsWith('/report-center')) return 'report-center';
  return null;
}

export function hasGrantModuleAccess(viewGrants, moduleKey) {
  if (!Array.isArray(viewGrants)) return false;
  return viewGrants.some((g) => g.moduleKey === moduleKey);
}

export function hasGrantTabAccess(viewGrants, moduleKey, tabKey) {
  if (!Array.isArray(viewGrants)) return false;
  return viewGrants.some((g) => {
    if (g.moduleKey !== moduleKey) return false;
    if (!g.tabKeys?.length) return true;
    return g.tabKeys.includes(tabKey);
  });
}

export function canViewModuleByGrant(role, viewGrants, moduleKey, roleAllowed) {
  if (role === ROLES.SPECTATOR) {
    return roleAllowed;
  }
  return roleAllowed || hasGrantModuleAccess(viewGrants, moduleKey);
}

export function canViewTabByGrant(role, viewGrants, moduleKey, tabKey, roleAllowed) {
  if (roleAllowed) return true;
  return hasGrantTabAccess(viewGrants, moduleKey, tabKey);
}

/** Store tab index to permission key */
export const STORE_TAB_KEYS = {
  0: 'dashboard',
  1: 'intent',
  2: 'reconciliation',
  3: 'tool-control',
  4: 'parts',
  5: 'access-logs',
  6: 'loan-items',
  7: 'work-order-requirements'
};

/** Maintenance tab keys (matches Maintenance.js TAB constant values) */
export const MAINTENANCE_TAB_KEYS = [
  'dashboard',
  'all',
  'standalone',
  'upcoming',
  'intimations',
  'edr',
  'history'
];
